module.exports = __webpack_public_path__ + "img/dzdp.c6ba76de.png";